import React from "react";
import { Calendar as Cal, Repeat, Leaf, Lock } from "lucide-react";

const FEATURES = [
  { i: <Cal className="h-5 w-5" />, t: "Monthly budget calendar", d: "Place bills on the days they're due. Add provider pay-links. Tick them off." },
  { i: <Repeat className="h-5 w-5" />, t: "Weekly reflection", d: "Three fields, five minutes. Cue, routine, reward — journaled." },
  { i: <Leaf className="h-5 w-5" />, t: "Category budgets", d: "Rent, utilities, groceries, subscriptions. See the month breathing." },
  { i: <Lock className="h-5 w-5" />, t: "Private & secure", d: "Email/password with bcrypt-hashed credentials. Your data stays yours." },
];

export default function Features() {
  return (
    <section id="features" className="bg-[#EAE7DF] py-20 border-y border-[#E6E3DB]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
          <div className="md:col-span-5">
            <p className="eyebrow text-[#C05C3D]">Features</p>
            <h2 className="font-serif text-4xl md:text-5xl mt-3">A quiet place for loud money.</h2>
          </div>
          <div className="md:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-6">
            {FEATURES.map((f) => (
              <div key={f.t} className="bg-white border border-[#E6E3DB] p-6" data-testid={`feature-${f.t}`}>
                <div className="h-9 w-9 rounded-sm bg-[#C05C3D]/10 text-[#C05C3D] flex items-center justify-center">
                  {f.i}
                </div>
                <h3 className="font-serif text-2xl mt-4">{f.t}</h3>
                <p className="text-[#4d4f4c] text-sm mt-2 leading-relaxed">{f.d}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
